<template>
    <div>
        <v-card-text>
            <i-beacon-message-table
                :search="search"
                :items="messages"
                :options="pagination"
                @edit="openEditIBeaconMessagePanel"/>
        </v-card-text>

        <right-panel
            ref="createIBeaconMessagePanel"
            :title="$t('ibeaconMessage.createHeader')">
            <template v-slot:content="{ context }">
                <i-beacon-message-details-view
                    ref="createIbeaconMesasgeDetailsView"
                    :ibeaconMessage="context"/>
            </template>

            <template v-slot:bottom>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onCreateIBeaconMessageSave">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>

        <right-panel
            ref="editIBeaconMessagePanel"
            :title="$t('ibeaconMessage.header')">
            <template v-slot:content="{ context }">
                <i-beacon-message-details-view
                    ref="editIbeaconMesasgeDetailsView"
                    :ibeaconMessage="context"/>
            </template>

            <template v-slot:bottom>
                <v-menu
                    top
                    offset-y
                    nudge-top="12px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            width="120px"
                            color="primary"
                            v-on="on"
                            v-bind="attrs">
                            <icon
                                class="mr-1"
                                value="hero_Trash"
                                size="18px"/>
                            {{ $t('button.delete') }}
                        </v-btn>
                    </template>
                    <v-card elevation="0">
                        <v-card-title class="error--text">
                            <icon
                                value="error_outline"
                                class="mr-2 error--text"/>
                            {{ $t('ibeaconMessage.dialog.delete.header') }}
                        </v-card-title>
                        <v-card-text v-html="$t('ibeaconMessage.dialog.delete.content')">
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                outlined
                                color="grey">
                                {{ $t('ibeaconMessage.dialog.delete.cancel') }}
                            </v-btn>
                            <v-btn
                                color="error"
                                @click="onClickConfirmDeleteMessage">
                                {{ $t('ibeaconMessage.dialog.delete.confirm') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onEditIBeaconMessageSave">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </div>
</template>

<script>
import IBeaconMessageTable from '@/components/tables/IBeaconMessageTable'
import IBeaconMessageDetailsView from '@/views/details/IBeaconMessageDetailsView'
import RightPanel from '@/components/panels/RightPanel'

import { mapGetters } from 'vuex'

export default {
    name: 'EventList',

    components: {
        IBeaconMessageTable,
        IBeaconMessageDetailsView,
        RightPanel
    },

    props: {
        messages: {
            type: Array,
            default: () => []
        },

        search: {
            type: String,
            default: ''
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        ...mapGetters({
            getIBeaconMessageById: 'ibeaconMessage/getIBeaconMessageById'
        })
    },

    methods: {
        async onCreateIBeaconMessageSave () {
            await this.$refs.createIbeaconMesasgeDetailsView.create()
            this.closeCreateIBeaconMessagePanel()
        },

        async onEditIBeaconMessageSave () {
            await this.$refs.editIbeaconMesasgeDetailsView.update()
            this.closeEditIBeaconMessagePanel()
        },

        async onClickConfirmDeleteMessage () {
            await this.$refs.editIbeaconMesasgeDetailsView.delete()
            this.closeEditIBeaconMessagePanel()
        },

        openCreateIBeaconMessagePanel () {
            this.$refs.createIBeaconMessagePanel.open({})
        },

        closeCreateIBeaconMessagePanel () {
            this.$refs.createIBeaconMessagePanel.close()
        },

        openEditIBeaconMessagePanel (item) {
            const ibeaconMessage = this.getIBeaconMessageById(item.id)

            if (ibeaconMessage) {
                this.$refs.editIBeaconMessagePanel.open(ibeaconMessage)
            }
        },

        closeEditIBeaconMessagePanel () {
            this.$refs.editIBeaconMessagePanel.close()
        }
    }
}
</script>

<style lang="scss" scoped></style>
